import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";
import http from "../http";

export interface DossierZoeklijstItem {
  kenmerk: string;
  naam: string;
  status: "ACTIEF" | "VOLTOOID" | "GEANNULEERD";
}

export function useDossierZoeklijst(options?: { enabled?: boolean }) {
  const { user } = useAuth();

  return useQuery<DossierZoeklijstItem[]>({
    queryKey: ["dossierZoeklijst", user?.id],
    queryFn: async (): Promise<DossierZoeklijstItem[]> => {
      const response = await http.get<DossierZoeklijstItem[]>(
        "/dossiers/zoeklijst",
      );
      return response.data;
    },
    enabled: !!user && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}
